import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import hasFeature from 'modules/core/lib/hasFeature'

import bookkeeperCollection from 'modules/bookkeepers/store/collections/bookkeepers'

import AdminBookkeeperBlock from './AdminBookkeeperBlock'

interface Props {
  canManagePayrollIncidences: boolean
}

const NotificationsSettings = ({ canManagePayrollIncidences }: Props) => {
  const showIncidenceUpdatesSettings =
    hasFeature('factorial_professionals') && canManagePayrollIncidences

  const { loading } = useAsyncData(() => {
    if (!showIncidenceUpdatesSettings) return Promise.resolve(null)

    return bookkeeperCollection.fetch()
  }, [])

  const {
    access: { id: currentAccessId },
  } = useCurrentSession()

  if (!showIncidenceUpdatesSettings) return null

  const is_bookkeeper = !!bookkeeperCollection.find({
    access_id: currentAccessId,
  })

  if (loading) {
    return (
      <Box width="full" alignItems="center">
        <Spinner />
      </Box>
    )
  }

  if (!is_bookkeeper) {
    return null
  }

  return <AdminBookkeeperBlock />
}

export default observer(NotificationsSettings)
